import state from '@/store/modules/auctions/defaultState';

const actions = {
  async getMyAcvActiveSellingAuctions({
    dispatch,
  }) {
    const auctions = await dispatch('auctions/getAuctionList', {
      subscribeAuctions: true,
      apiMethod: 'getMyAcvActiveSellingAuctions',
      moduleKey: 'MyAcvActive.MyAcvActiveSelling',
      numberOfLoaders: 3,
      page: 1,
    }, {
      root: true,
    });
    return auctions;
  },
};

export default {
  state,
  actions,
};
